export type SourcesColumn = {
  bit: number;
  label: string;
};

export const SourcesColumns = {
  delete: { bit: 0, label: "" },
  type: { bit: 1, label: "Type" },
  contact: { bit: 2, label: "Contact" },
  companyName: { bit: 3, label: "Company Name" },
  initialFunds: { bit: 4, label: "Initial Funds" },
  fundsAdjustment: { bit: 5, label: "FundsAdjustment" },
  netFunds: { bit: 6, label: "Net Funds" },
  fundsDisbursed: { bit: 7, label: "Funds Disbursed" },
  totalFundsDisbursed: { bit: 8, label: "Total Funds Disbursed" },
  balance: { bit: 9, label: "Funds Avail" },
  totalPrincipalReduction: { bit: 10, label: "Total Principal Reduction" },
  totalFundsRetained: { bit: 11, label: "Retain Balance" },
  totalFundsAdjustment: { bit: 12, label: "Total Funds Adj" },
  targetTotalFunds: { bit: 13, label: "Target Total Funds" },
  closingCosts: { bit: 14, label: "Closing Costs" },
  principalReduction: { bit: 15, label: "Principal Reduction" },
  defaultPayee: { bit: 16, label: "Default Payee" },
};
